import {useEffect, useRef} from 'external/react'
import {renderMathInElement} from 'external/katex'

export default function MathHtml({html = '', ...props}) {
  const element = useRef(null)
  const content = html || ''
  useEffect(() => {
    if (!element.current) return
    try {
      renderMathInElement(element.current, {
        delimiters: [
          {left: '\\(', right: '\\)', display: false},
          {left: '\\[', right: '\\]', display: true},
        ],
        throwOnError: false,
        ignoredTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code', 'option'],
      })
    } catch (error) {
      console.warn('Unable to render imported-assessment mathematics', error)
    }
  }, [content])
  return <div {...props} ref={element} dangerouslySetInnerHTML={{__html: content}} />
}
